import { useTranslate } from "@similarweb/i18n-provider";

import { hasCrmPermissions } from "app/components/SideBar/utils";
import FiltersListLoader from "app/pages/sales-intelligence/common-components/filters-panel/components/FiltersListLoader/FiltersListLoader";
import { useCrmCustomFiltersListViewModel } from "app/pages/sales-intelligence/modules/crm-integration/hooks/useCrmCustomFiltersListViewModel";
import siNavigator from "app/pages/sales-intelligence/services/siNavigator";

import ConnectionLink from "../../components/filters/ExcludeByCrmFilter/ConnectionLink/ConnectionLink";

import { StyledCrmEmptyState } from "./styles";

const NotConnectedCta = () => {
    const { translate } = useTranslate();

    return (
        <ConnectionLink
            hasAccess={hasCrmPermissions()}
            onClick={() => {
                void siNavigator.goToManagementPage();
            }}
            tooltipContent={translate("si.lead_gen_filters.category.exclude.notConnected.link.tooltip", {
                integrationName: "",
            })}
            content={translate("si.lead_gen_filters.notConnected.text", {
                integrationName: "",
            })}
        />
    );
};

export const CrmCategoryEmptyState = () => {
    const { translate } = useTranslate();

    const { state } = useCrmCustomFiltersListViewModel();

    if (state === "loading") {
        return <FiltersListLoader rowNumber={3} />;
    }

    if (state === "notConnected") {
        return (
            <StyledCrmEmptyState
                iconName="no-data-lab"
                title={translate("si.lead_gen_filters.crm.notConnected.title")}
                subtitle={translate("si.lead_gen_filters.crm.notConnected.subtitle")}
                CtaButtons={NotConnectedCta}
            />
        );
    }

    return null;
};
